import {Component} from "@angular/core";
import {LookupService} from "../../lookup.service";

@Component({
  selector: "admin-lookup-common-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.css"]
})
export class AdminLookupCommonFormComponent {

  constructor(
    private singleService: LookupService,
  ) {
  }

  getDefinition() {
    return this.singleService.definition;
  }

  getFields() {
    return this.singleService.fields;
  }

  onUpload(file: File) {
    console.log("Logic got file:", file.name);
    this.singleService.upload(file);
  }

}
